import { Text } from '@thanx/uikit/text'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'
import { PROMO_CREDIT_CENTS, RECOVERIES_COUNT } from './constants'
import { formatCentsUsd } from './format'

const t = buildTranslate('recovery_ai.activation.pricing_modal.credit')

const PANEL_PADDING = '22px'
const TILE_PADDING = '16px 18px'
// The tile/copy gap and the copy's left padding straddle the divider, so it lands
// 22px clear of the tile on both sides.
const TILE_DIVIDER_GAP = '22px'

// The "$250 free credits" panel in the activation pricing modal: a tinted panel
// holding a white tile, a divider, and the headline + body.
//
// Three colour choices deliberately deviate from a naive read of the design, all
// for contrast (measured against utilities/contrast):
//   - $250 uses spearmint60 (3.29:1 on white). It clears AA only because Header3 is
//     24px bold, i.e. WCAG large text. palette.spearmint is 2.23:1 and fails even
//     that, so it cannot be used here.
//   - "Free Credits" is grey70 (4.75:1), not teal — at BodyText5/12px it is normal
//     text and needs 4.5:1, which spearmint60's 3.29:1 misses.
//   - The heading and body are grey90, not the house grey70: grey70 on spearmint10
//     is 4.37:1, just under AA.
const CreditPanel = () => {
  const [css] = useStyletron()
  return (
    <div
      className={`d-flex align-items-center ${css({
        backgroundColor: palette.spearmint10,
        borderRadius: '4px',
        padding: PANEL_PADDING,
        gap: TILE_DIVIDER_GAP,
      })}`}
    >
      <div
        className={`text-center ${css({
          backgroundColor: palette.white,
          borderRadius: '4px',
          flexShrink: 0,
          padding: TILE_PADDING,
          boxShadow: '0px 1px 2px 0px rgba(54, 66, 78, 0.3)',
        })}`}
      >
        {/* spearmint60 is not on the uikit theme, so it can't go through the Text
            `color` prop — apply it as a styletron class. */}
        <Text.Header3
          tag="div"
          bold
          className={css({ color: palette.spearmint60 })}
        >
          {formatCentsUsd(PROMO_CREDIT_CENTS)}
        </Text.Header3>
        <Text.BodyText5 tag="div" color="grey70">
          {t('amount_label')}
        </Text.BodyText5>
      </div>

      <div
        className={css({
          flex: 1,
          borderLeft: `1px solid ${palette.grey20}`,
          paddingLeft: TILE_DIVIDER_GAP,
        })}
      >
        <Text.BodyText3 tag="div" bold color="grey90">
          {t('heading', { recoveries: RECOVERIES_COUNT })}
        </Text.BodyText3>
        <Text.BodyText4 tag="div" color="grey90" className="mt-xs">
          {t('body', {
            amount: formatCentsUsd(PROMO_CREDIT_CENTS),
            recoveries: RECOVERIES_COUNT,
          })}
        </Text.BodyText4>
      </div>
    </div>
  )
}

export default CreditPanel
